import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function AuthAwareLink({ spaPath, staticPath, children, ...rest }) {
  const { isAuthenticated, loading } = useAuth();

  if (!loading && isAuthenticated) {
    return (
      <Link to={spaPath} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <a href={staticPath} {...rest}>
      {children}
    </a>
  );
}

export default AuthAwareLink;
